import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axiosInstance from "../../axiosConfig";

import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import MetaData from "../layouts/MataData/MataData";
import logo from "../../Image/logo2.jpeg";
import "./BookingForm.css";

export default function BookingForm() {
  const [startDate, setStartDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const history = useHistory();
  const alert = useAlert();

  const { name, email, phone, message } = formData;

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isBookedDisabled = !(
    formData.name &&
    formData.email &&
    formData.phone &&
    formData.message &&
    selectedTime &&
    isValidEmail(formData.email)
  );

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    const reservationData = {
      ...formData,
      date: startDate,
      time: selectedTime,
    };

    try {
      const response = await axiosInstance.post("/api/v1/reservations", reservationData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201) {
        alert.success("Réservation envoyée avec succès!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
        setStartDate(new Date());
        setSelectedTime("");
      } else {
        alert.error(response.data.error || "Une erreur s'est produite");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        alert.error(error.response.data.error);
      } else {
        alert.error("Erreur du serveur, veuillez réessayer plus tard.");
      }
    }
  };

  const timeSlots = [
    "09h-10h",
    "10h-11h",
    "11h-12h",
    "14h-15h",
    "15h-16h",
    "16h-17h",
    "17h-18h",
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <MetaData title="Reservation" />
      <div
        className="container "
        style={{
          marginTop: "10rem",
          marginBottom: "3rem",
          maxWidth: "400px",
          // Center horizontally
        }}
      >
        <form
          onSubmit={handleBookingSubmit}
          className="p-4  rounded  w-70"
          style={{
            backgroundColor: "#ffffff", // Light white background
            boxShadow: "10px 4px 10px rgba(0, 0, 0, 0.1)",
            border: " 1px solid #000", // Subtle box shadow
          }}
        >
          <div className="text-center mb-4">
            <img src={logo} alt="Logo" className="rounded-circle" style={{ width: "90px" }} />
            <h3 className="mt-3" style={{ textAlign: "center",
    marginBottom: "2rem",
    color: "#414141",
    fontWeight: "bold", }}>Prendre un Rendez-Vous!!</h3>
          </div>
          <div className="mb-3" >
            <label htmlFor="name" className="form-label">
              Nom complet*
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              Numéro de Téléphone*
            </label>
            <input
              type="tel"
              className="form-control"
              id="phone"
              name="phone"
              value={phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email*
            </label>
            <input
              type="email"
              className={`form-control ${
                !isValidEmail(email) && email !== "" ? "is-invalid" : ""
              }`}
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              required
            />
            {!isValidEmail(email) && email !== "" && (
              <div className="invalid-feedback">Veuillez entrer une adresse e-mail valide.</div>
            )}
          </div>
          <div className="date-picker-div mb-3 w-100">
  <label htmlFor="date" className="form-label">
    Date*
  </label>
  <DatePicker
    selected={startDate}
    onChange={(date) => setStartDate(date)}
    dateFormat="dd/MM/yyyy"
    minDate={new Date()}
    className="form-control datepicker-input"  // Custom class here
    id="date"
    required
  />
</div>



          <div className="mb-3 ">
            <label htmlFor="time" className="form-label">
              Heure*
            </label>
            <select
              className="form-select "
              id="time"
              value={selectedTime}
              onChange={(e) => setSelectedTime(e.target.value)}
              required
            >
              <option value="" disabled>
                Heure
              </option>
              {timeSlots.map((slot) => (
                <option key={slot} value={slot}>
                  {slot}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="message" className="form-label">
              Message*
            </label>
            <textarea
              className="form-control"
              id="message"
              name="message"
              rows="4"
              value={message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="btn  w-100"
            disabled={isBookedDisabled}
            style={{
              backgroundColor: "#ed1c24",
              color: "#fff",
            }}
          >
            Envoyer
          </button>
        </form>
      </div>
    </>
  );
}
